import { useMutation } from 'react-query';
import updateRequestStatus from '../../../requests/updateRequestStatus';

const useChangeRequestStatusMutation = (options) =>
  useMutation(
    ({ requestId, statusId }) => updateRequestStatus(requestId, statusId),
    options
  );

export default useChangeRequestStatusMutation;
